import "./App.css";
import ThemeProvider from "./theme/ThemeProvider";
import { useRoutes } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import router from "./router";
import { SnackBarAlertProvider } from "./contexts/SnackbarContext";
import { EntityProvider } from "./contexts/EntityContext";

function App() {
  const content = useRoutes(router());

  return (
    <ThemeProvider>
      <SnackBarAlertProvider>
        <EntityProvider>
          <CssBaseline />
          {content}
        </EntityProvider>
      </SnackBarAlertProvider>
    </ThemeProvider>
  );
}

export default App;
